/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { AnyAction } from 'redux';
import { AUTH_LOGOUT } from '../../../constants/auth.constants';
import { UPDATE_PROFILE, CLEAR_PROFILE } from '../../../constants/profile.constants';
import ProfileState from '../../../models/redux/state/profile.state';

const initialState: ProfileState = {
  current: undefined,
};

const profileReducer = produce((draft: ProfileState, action: AnyAction) => {
  switch (action.type) {
    case UPDATE_PROFILE:
      draft.current = action.profile;
      break;
    case CLEAR_PROFILE:
      draft.current = initialState.current;
      break;
    case AUTH_LOGOUT:
      draft.current = initialState.current;
      break;
    default:
  }
}, initialState);

export default profileReducer;
